import * as React from 'react';
import Page from 'components/Page';
import { Button, Row, Col, Input, Label, FormGroup } from 'reactstrap';
import DynamicTable from 'components/DynamicTable';
import bgimage from '../assets/img/icon/ms-excel.png';
import ReactExport from "react-data-export";
import { connect } from 'react-redux';
import * as loginSelectors from 'store/login/reducer';
import BaseService from '../services/BaseService';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
 
class ReportAdviserPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            date_from: this.returnDate(),
            date_to: this.returnDate("to"),
            show_form_route: false,
            show_deleting: false,
            dateFrom: false,
            dateTo: false,
            columns: [
                { name: 'id', title: 'ID' },
                { name: 'name', title: 'Nome' },
                { name: 'value', title: 'Value' },
                { name: 'created', title: 'Data da Compra' }
            ],
            exportData: [],
            reload: false,
            editingObj: null,
            delete_id: -1
        };
        this.getReportExcel = this.getReportExcel.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        this.getReportExcel();
        this.setState({
            date_from: this.returnDate(),
            date_to: this.returnDate("to"),
            reload: !this.state.reload
        })
    }
    getResults() {
        var dat = [];
        for(var i=0; i<this.state.exportData.length; i++){
            dat.push(
                [
                    { value: this.state.exportData[i].id },
                    { value: this.state.exportData[i].name },
                    { value: "R$"+parseFloat(this.state.exportData[i].value).toFixed(2) },
                    { value: this.state.exportData[i].created }
                ]
            )
        }
        const multidataSet = [
            {
                columns: [
                    {   title: "ID", width: {wpx: 80} },//pixels width 
                    {   title: "Nome", width: {wch: 40}},//char width 
                    {   title: "Valor da Venda", width: {wpx: 140}},
                    {   title: "Data", width: {wpx: 90}},
                ],
                    data: dat,
            }
        ]
        return multidataSet
    }
    onReloded = () =>{
        this.setState({
            reload: !this.state.reload
        })
        this.getReportExcel();
    }
    getReportExcel() {
        fetch(BaseService.ENDPOINT + this.returnApi(), {
            method: 'GET',
            headers: new Headers({
                Accept: 'application/json',
                Authorization: 'Bearer ' + this.props.user.access_token
            })
        })
        .then(results => {
            return results.json();
        })
        .then(data => {
            if (data.return.code === 1) {
                this.setState({
                    exportData: data.data.data
                })
            } else if (data.return.code > 300) {
                window.location = '/';
            }
        })
    }
    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
            [name]: value,
        });
    }
    returnApi = () => {
        var date1 = this.state.date_from;
        var date2 = this.state.date_to;
        date1 = date1.replace("/", "-").replace("/", "-");
        date2 = date2.replace("/", "-").replace("/", "-");
        var date = "admin/statistics/sales-monitor/" + date1 + "/" + date2 + "";
        return date
    }
    
    returnDate(type) {
        var da = new Date();
        var mounth = da.getMonth() + 1;
        var year = da.getFullYear();
        var data = new Date(year, mounth, 0);
        var day = data.getDate();
        if (da.getMonth() + 1 < 10) {
            mounth = "0" + (da.getMonth() + 1);
        }
        if (type === "to") {
            return year + "-" + mounth + "-" + day;
        } else {
            day = "01";
            return year + "-" + mounth + "-" + day;
        }
    }

    render() {
        return (
            <Page
                title="Relatório de Vendas dos Monitores por Dia"
                className="UserAdviserPage">
                <Row>
                    <Col sm={3}>
                        <ExcelFile element={<Button outline><img src={bgimage} alt="excel" /> Exportar para Excel</Button>}>
                            <ExcelSheet dataSet={this.getResults()} name="Employees">
                            </ExcelSheet>
                        </ExcelFile>
                        <br />
                    </Col>
                </Row>
                <Row>
                    <Col sm={3} >
                        <FormGroup>
                            <Label >De: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_from"
                                value={this.state.date_from}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateFrom}
                                max={this.state.date_to}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={3}   >
                        <FormGroup>
                            <Label>Até: </Label>
                            <Input
                                type="date"
                                maxLength={10}
                                name="date_to"
                                value={this.state.date_to}
                                onChange={this.handleInputChange}
                                invalid={this.state.dateTo}
                                min={this.state.date_from}
                            ></Input>
                        </FormGroup>
                    </Col>
                    <Col sm={3}>
                    <br/>
                        <Button 
                            outline 
                            onClick={this.onReloded}
                            style={{
                                marginTop: '7px'
                            }}
                        > Procurar</Button>
                    </Col>
                </Row>
                <DynamicTable
                    route="true"
                    hideButton={true}
                    user={this.props.user}
                    api={this.returnApi()}
                    columns={this.state.columns}
                    dateFilter="false"
                    integratedFilter="false"
                    currencyColumns="false"
                    showPagingState="false"
                    filterState="false"
                    integratePag="false"
                    reload={this.state.reload}
                />
                
            </Page>
        );
    }
};


// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
    const currentUser = loginSelectors.getUser(state);
    return {
        user: currentUser
    };
}
export default connect(mapStateToProps)(ReportAdviserPage)


// WEBPACK FOOTER //
// ./src/pages/ReportAdvisorPage.js